import { render } from "./Q4-Poem.vue?vue&type=template&id=05f33714&scoped=true"
import script from "./Q4-Poem.vue?vue&type=script&lang=js"
export * from "./Q4-Poem.vue?vue&type=script&lang=js"

import "./Q4-Poem.vue?vue&type=style&index=0&id=05f33714&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f33714"]])

export default __exports__